export default "__VITE_ASSET__D1fIBUd0__"